import { useEffect, useState } from "react";

export const DecisionProcessMobile = () => {
  const [isLoaded, setIsLoaded] = useState(false);
  const [activeStep, setActiveStep] = useState(0);

  useEffect(() => {
    const loadTimer = setTimeout(() => setIsLoaded(true), 100);
    
    // Cycle through steps
    const stepInterval = setInterval(() => {
      setActiveStep((prev) => (prev + 1) % 4);
    }, 2500);

    return () => {
      clearTimeout(loadTimer);
      clearInterval(stepInterval);
    };
  }, []);

  const steps = [
    { label: "Kontext" },
    { label: "Optionen" },
    { label: "Trade-offs" },
    { label: "Entscheidung" },
  ];

  // Calculate progress percentage based on active step (0-100)
  const progressPercent = (activeStep / (steps.length - 1)) * 100;

  return (
    <div 
      className={`w-full transition-all duration-700 ${
        isLoaded ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'
      }`}
    >
      {/* Stepper container */}
      <div className="relative flex items-center justify-between px-4">
        {/* Connection line container - positioned between first and last node centers */}
        <div className="absolute left-4 right-4 top-4 flex items-center">
          {/* Calculate line position: offset by half node width (16px) on each side */}
          <div className="relative w-full mx-4">
            {/* Background line */}
            <div className="absolute inset-0 h-[2px] bg-border/40 rounded-full" />
            
            {/* Animated progress line */}
            <div 
              className="absolute left-0 top-0 h-[2px] bg-primary rounded-full transition-all duration-700 ease-out"
              style={{ width: `${progressPercent}%` }}
            />
          </div>
        </div>

        {/* Step nodes */}
        {steps.map((step, index) => {
          const isActive = activeStep === index;
          const isPast = index < activeStep;
          
          return (
            <div
              key={index}
              className="relative z-10 flex flex-col items-center"
            >
              {/* Node */}
              <div 
                className={`relative w-8 h-8 rounded-full flex items-center justify-center transition-all duration-500 ${
                  isActive 
                    ? 'bg-primary text-primary-foreground scale-110 shadow-lg shadow-primary/30' 
                    : isPast
                    ? 'bg-primary/80 text-primary-foreground'
                    : 'bg-card border-2 border-border/60 text-muted-foreground'
                }`}
              >
                <span className="text-xs font-semibold">
                  {index + 1}
                </span>
                
                {/* Active pulse ring */}
                {isActive && (
                  <div className="absolute -inset-1.5 rounded-full border-2 border-primary/30 animate-[pulse_2s_ease-in-out_infinite]" />
                )}
              </div>
              
              {/* Label */}
              <span 
                className={`mt-2 text-[10px] font-medium transition-all duration-300 whitespace-nowrap ${
                  isActive 
                    ? 'text-foreground' 
                    : isPast
                    ? 'text-primary'
                    : 'text-muted-foreground/60'
                }`}
              >
                {step.label}
              </span>
            </div>
          );
        })}
      </div>

      {/* Subtle hint text */}
      <p className="text-center text-[10px] text-muted-foreground/50 mt-4">
        4 Phasen zur verbindlichen Entscheidung
      </p>
    </div>
  );
};
